export const PARTICIPANT_LIST = "participant-list";
export const SETTINGS_LIST = "settings-list";
export const CHAT_LIST = "chat-list";
